<template>
  <div class="workflow-container min-vh-100">
    <LoadingSpinner v-if="loading" class="mt-5" />
    <div class="min-vh-100" v-else>
      <AutomationFlowHeader :isLoadingSave="isLoadingSave" :workflowMode="workflowModeAccordingStatus" />
      <sidebar @closeSidebar="closeSidebar" :showSidebar="isSidebarOpen" :title="selectedStepTitle">
        <template #asideContent>
          <transition name="fade">
            <div class="w-50 mx-auto">
              <MenssageAlert :messages="messages" />
            </div>
          </transition>
          <AutomationFlow v-if="reloadFlowControl" class="py-5" @select-block="setStep" />
        </template>

        <template #collapsedContent>
          <!-- ** v-c-tooltip não suporta valores nulos, foi necessário essa duplicata de código que deve ser corrigida na migração para NUXT  -->
          <div v-if="isSelectedStepDisabled" v-c-tooltip.hover="$t('automation.workflow.step.disabled')">
            <div :class="{ 'cursor-not-allowed opacity-50': isSelectedStepDisabled }" class="px-3 py-3">
              <div :class="{ 'pointer-events-none': isSelectedStepDisabled }">
                <component
                  :data-block="selectedStep.name"
                  ref="selectedComponent"
                  v-if="selectedStep"
                  :is="selectedStep.component"
                  :indexStep="indexStep"
                  @update-field="updateField"
                  @update-form-validation="handleCurrentStepFormValidation"
                />
              </div>
            </div>
          </div>
          <div v-else>
            <div :class="{ 'cursor-not-allowed opacity-50': isSelectedStepDisabled }" class="px-3 py-3">
              <div :class="{ 'pointer-events-none': isSelectedStepDisabled }">
                <component
                  :data-block="selectedStep.name"
                  ref="selectedComponent"
                  v-if="selectedStep"
                  :is="selectedStep.component"
                  :indexStep="indexStep"
                  @update-field="updateField"
                  @update-form-validation="handleCurrentStepFormValidation"
                />
              </div>
            </div>
          </div>
        </template>
      </sidebar>
    </div>
  </div>
</template>
<script>
import Sidebar from '../components/AutomationSidebar.vue'
import Details from '../components/AutomationForm.vue'
import Action from '../components/AutomationAction.vue'
import SMSContent from '../components/AutomationSMSContent.vue'
import EmailContent from '../components/AutomationEmailContent.vue'
import AutomationFlow from '../components/Flow/AutomationFlow.vue'
import AutomationFlowHeader from '../components/Flow/AutomationFlowHeader.vue'
import Audience from '../components/AutomationAudience.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { STEP_TYPES, STEP_MODEL, FIELD_TYPE, CHANNEL_TYPES, WORKFLOW_MODES, STATE_TYPES } from '../constants'
import MenssageAlert from '@/components/MenssageAlert'

export default {
  name: 'AutomationWorkflow',
  components: {
    Sidebar,
    Details,
    Action,
    SMSContent,
    EmailContent,
    Audience,
    AutomationFlow,
    AutomationFlowHeader,
    LoadingSpinner,
    MenssageAlert,
  },
  data() {
    return {
      teste: undefined,
      loading: false,
      reloadFlowControl: true,
      selectedStep: undefined,
      STEP_TYPES: STEP_TYPES,
      STATE_TYPES: STATE_TYPES,
      STEP_MODEL: STEP_MODEL,
      WORKFLOW_MODES: WORKFLOW_MODES,
      isSidebarOpen: false,
      workflowData: undefined,
      indexStep: 0, //TODO: TORNAR VALOR DINAMICO DE ACORDO COM ACTION SELECIONADA E RENOMEAR PARA ALGO RELACIONADO A ACTION
      timeoutControll: null,
      isLoadingSave: false,
      messages: [],
    }
  },
  computed: {
    selectedStepTitle() {
      const translationKey = this.selectedStep?.translationKey

      if (!translationKey) return
      return this.$t(`automation.workflow.step.${translationKey}.title`)
    },
    workflowModeAccordingStatus() {
      const status = this.workflowData?.workflowStatus
      if (status === this.STATE_TYPES.ENABLED) return this.WORKFLOW_MODES.VIEW

      if (status === this.STATE_TYPES.DISABLED) return this.WORKFLOW_MODES.EDIT

      return
    },
    isSelectedStepDisabled() {
      if (this.workflowModeAccordingStatus == WORKFLOW_MODES.VIEW) return true

      if (this.workflowModeAccordingStatus == WORKFLOW_MODES.EDIT) return this.selectedStep?.disabledOnEditMode

      return false
    },
  },
  mounted() {
    this.getData(this.validateAutomation)
  },
  methods: {
    updateField(obj) {
      if (this.workflowModeAccordingStatus == this.WORKFLOW_MODES.VIEW) return

      if (this.timeoutControll) clearTimeout(this.timeoutControll)

      let { organizationId, workflowId } = this.$route.params

      switch (obj.type) {
        case FIELD_TYPE.WORKFLOW:
          this.$store.commit('automation/SET_WORKFLOW_PROPERTY', obj)
          break
        case FIELD_TYPE.TRIGGER:
          this.$store.commit('automation/SET_TRIGGER_PROPERTY', obj)
          break
        case FIELD_TYPE.STEP:
          this.$store.commit('automation/SET_STEP_PROPERTY', obj)
          break
        case FIELD_TYPE.CONTROL:
          this.$store.commit('automation/SET_CONTROL_PROPERTY', obj)
          break
        default:
          return
      }

      this.reloadFlowControl = false
      this.$nextTick(() => {
        this.reloadFlowControl = true
      })

      this.validateAutomation()

      this.timeoutControll = setTimeout(() => {
        this.isLoadingSave = true
        this.$store
          .dispatch('automation/updateWorkflow', { organizationId, workflowId })
          .then((workflowData) => {
            if (workflowData.updateConflictDetected) {
              this.showConflictMessage()
            }
          })
          .finally(() => {
            this.isLoadingSave = false
          })
      }, 1500)
    },
    handleCurrentStepFormValidation(isFormInvalid) {
      this.selectedStep.isFormInvalid = isFormInvalid
      this.validateAutomation()
    },
    getData(callback) {
      let { organizationId, workflowId } = this.$route.params
      this.loading = true
      this.$store
        .dispatch('automation/getAutomation', { organizationId, workflowId })
        .then((res) => {
          this.workflowData = res
          this.handleWorkflowData()
          callback()
        })
        .finally(() => (this.loading = false))
    },
    findStep(stepName) {
      return this.STEP_MODEL.find((el) => el.name == stepName)
    },
    // ? Depreciado -> Substituido pelo getData
    // async getWorkflowData() {
    //   const response = await services.getAutomation(this.$route.params.organizationId, '8afd3836-ee91-47d7-a37d-9662e9db07fb')
    //   this.workflowData = response.data.data
    //   this.handleWorkflowData()
    // },
    handleWorkflowData() {
      const template = this.$route.params.template
      const indexStep = this.$route.params.indexStep
      const hasIndexStep = indexStep !== undefined && indexStep !== null

      if (template?.id && hasIndexStep) this.setEmailTemplateStep(template)
    },
    setEmailTemplateStep(template) {
      const templateIdField = {
        property: 'templateId',
        value: template.id,
        type: FIELD_TYPE.STEP,
      }

      this.updateField(templateIdField)

      const templateEmailField = {
        property: 'templateEmail',
        value: template,
        type: FIELD_TYPE.CONTROL,
      }

      this.updateField(templateEmailField)
    },
    setMainWorkflow(workflowJson) {
      this.$store.dispatch('automation/setMainWorkflow', workflowJson)
    },
    setStep(stepName) {
      const toggleSideBarValue = true

      this.isSidebarOpen = toggleSideBarValue

      if (!toggleSideBarValue) {
        this.$store.dispatch('automation/clearCurrentStep')
        return
      }

      this.selectedStep = this.findStep(stepName)

      if (!this.selectedStep) return

      this.$store.dispatch('automation/setCurrentStep', {
        indexStep: this.selectedStep.id,
        currentStepType: this.selectedStep.name,
      })
      switch (stepName) {
        case this.STEP_TYPES.AUTOMATION_DETAIL:
          this.loadAutomation()
          break
        default:
          break
      }
    },
    loadAutomation() {
      this.$nextTick(() => {
        if (!this.$refs.selectedComponent) return
        let name = this.$store.state.automation.mainWorkflow.name

        let obj = this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0]?.data

        let formData = { name, ...obj }

        this.$refs.selectedComponent.loadForm(formData)
      })

      // this.$refs.selectedComponent.loadForm()
    },
    validateAutomation() {
      this.validateDetails()
      this.validateAudience()
      this.validateAction()
      if (this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0]?.type == CHANNEL_TYPES.SEND_SMS) {
        this.validateSMSContent()
      } else if (this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0]?.type == CHANNEL_TYPES.SEND_EMAIL) {
        this.validateEmailContent()
      }
    },
    validateDetails() {
      if (
        this.$store.state.automation.mainWorkflow.name == null ||
        this.$store.state.automation.mainWorkflow.name == '' ||
        this.$store.state.automation.mainWorkflow.name.length < 3 ||
        this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0]?.data?.triggerDate == null ||
        this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0]?.data?.triggerOffsetInMinutes == null ||
        this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0]?.data?.timezone == null ||
        this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0]?.data?.dateFieldName == null ||
        this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0]?.data?.schedulingTime == null
      ) {
        this.$store.commit('automation/SET_VALIDATION_DETAIL', false)
        return false
      }
      this.$store.commit('automation/SET_VALIDATION_DETAIL', true)
      return true
    },
    validateAudience() {
      if (
        this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0]?.data?.segmentId == null ||
        this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0]?.data?.segmentId == undefined
      ) {
        this.$store.commit('automation/SET_VALIDATION_AUDIENCE', null)
        return false
      } else if (Array.isArray(this.$store.state.automation.mainWorkflow.workflowJson.triggers.values[0].data.segmentId)) {
        this.$store.commit('automation/SET_VALIDATION_AUDIENCE', true)
        return true
      } else {
        this.$store.commit('automation/SET_VALIDATION_AUDIENCE', false)
        return false
      }
    },
    validateAction() {
      if (
        this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0]?.type == null ||
        this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0]?.type == undefined
      ) {
        this.$store.commit('automation/SET_VALIDATION_ACTION', null)
        return false
      } else if (
        this.$store.state.automation.controls.channelType ||
        this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0]?.type != null
      ) {
        this.$store.commit('automation/SET_VALIDATION_ACTION', true)
        return true
      }
    },
    validateSMSContent() {
      const data = this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0]?.data

      const hasTemplateId = data?.templateId !== null && data?.templateId !== undefined

      if (hasTemplateId) {
        const hasRequiredFieldNull =
          data?.senderId == null || data?.senderName == null || data?.templateId == null || data?.templateId == '00000000-0000-0000-0000-000000000000'

        const hasRequiredFields = data?.senderId && data?.senderName && data?.templateId

        if (hasRequiredFieldNull) {
          this.$store.commit('automation/SET_VALIDATION_CONTENT', null)
          return
        }

        if (hasRequiredFields) {
          this.$store.commit('automation/SET_VALIDATION_CONTENT', true)
          return
        } else {
          this.$store.commit('automation/SET_VALIDATION_CONTENT', false)
          return
        }
      } else {
        const hasRequiredFieldNull = data?.senderId == null || data?.senderName == null || data?.text == null
        const hasRequiredFields = data?.senderId && data?.senderName && data?.text

        if (hasRequiredFieldNull) {
          this.$store.commit('automation/SET_VALIDATION_CONTENT', null)
          return
        }

        if (hasRequiredFields) {
          this.$store.commit('automation/SET_VALIDATION_CONTENT', true)
          return
        } else {
          this.$store.commit('automation/SET_VALIDATION_CONTENT', false)
          return
        }
      }
    },
    validateEmailContent() {
      const data = this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0]?.data

      const hasContentType = data?.contentType !== null && data?.contentType !== undefined
      const hasRequiredFields = data?.templateId && data?.senderId && data?.subject && data?.from && hasContentType

      const hasRequiredFieldNull = data?.templateId == null || data?.senderId == null || data?.subject == null || data?.from == null

      if (hasRequiredFieldNull) {
        this.$store.commit('automation/SET_VALIDATION_CONTENT', null)
        return
      }

      if (hasRequiredFields && !this.selectedStep.isFormInvalid) {
        this.$store.commit('automation/SET_VALIDATION_CONTENT', true)
        return
      } else {
        this.$store.commit('automation/SET_VALIDATION_CONTENT', false)
        return
      }
    },
    closeSidebar() {
      this.isSidebarOpen = false
      this.$store.commit('automation/CLEAR_CURRENT_STEP')
      return this.$router.push({ hash: null })
    },
    showConflictMessage() {
      this.messages = [
        {
          status: 'warning',
          text: this.$t('automation.workflow.update-conflict'),
        },
      ]
    },
  },
}
</script>
<style lang="scss">
.workflow-container {
  background-color: $gray-100;
}
</style>
